import { css, jsx } from '@emotion/core';
import { useRouter } from 'next/router';
import React from 'react';

import ChartProfiles from '@/src/profile/ChartProfiles';
import Container from '@/src/shared/components/Container';
import Head from '@/src/shared/components/Head';
import Hero from '@/src/shared/components/Hero';
import Layout from '@/src/shared/components/Layout';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import request from '@/utils/axios';

const style = {
  section: css`
    padding-top: 0px !important;
  `,
};
const PublicAffairsStaff = props => {
  const router = useRouter();
  const { data } = props;
  const { route } = router;
  const { PageTitle, Profiles } = data;
  const enableBio = true;

  return (
    <Layout>
      <Head title={PageTitle} />
      <Hero title={PageTitle} />
      <Section css={style.section}>
        <Container>
          <ChartProfiles profiles={Profiles} route={route} enableBio={enableBio} />
        </Container>
      </Section>
      <WebLogImage browserPath title={PageTitle} />
    </Layout>
  );
};

export async function getStaticProps() {
  try {
    const response = await request({
      url: `profile/chartprofiles`,
      method: 'GET',
      params: {
        chartid: 8,
      },
    });
    const { data } = response;

    return { props: { data } };
  } catch (err) {
    return {
      props: {
        error: true,
      },
    };
  }
}

export default PublicAffairsStaff;
